module.exports = __webpack_public_path__ + "img/guozai_06.90c07d02.jpg";